export const getMinMax = (array: any[], attribute: string): [number, number] => {
    let min = 100;
    let max = 0;
    array.forEach(x => {
        if(x[attribute] > max) max = x[attribute];
        if(x[attribute] < min) min = x[attribute]
    })
    return [min, max];
}
export const getDistinct = (array: any[], attribute: string, returnWholeObject=false): any[] => {
    const distinct: any[] = [];
    array.forEach(a => {
        if(returnWholeObject){
            if(a[attribute] && !(distinct.find(da => da[attribute] === a[attribute]))) distinct.push(a);
        } else if(a[attribute] && !distinct.includes(a[attribute])) {
            if(returnWholeObject) distinct.push(a)
            else distinct.push(a[attribute]);
        }
    })
    if(returnWholeObject) return distinct.sort((a, b) => (a[attribute] < b[attribute]) ? -1 : 1);
    else return distinct.sort((a, b) => (a < b) ? -1 : 1);

}